export default {
  pageName: 'Keyword Analysis List',
  pageId: '25081',
  pagePath: '/opinion/AIAnalysisHub/KeywordAnalysis?tab=savedAnalysisList',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    PreviewAnalysis: {
      buttonId: '2508101',
    },
    SearchAnalysis: {
      buttonId: '2508102',
    },
    DownloadReport: {
      buttonId: '2508103',
    },
    Delete: {
      buttonId: '2508104',
    },
    Stop: {
      buttonId: '2508105',
    },
  },
};
